import { MultiSelect } from './MultiSelect';

export const AssaySelector = ({disabled, assays, selectedAssays, onChange }) => {
  return (
    <div className="mb-3 card card-body">
      <label className="form-label" htmlFor="assaySelector">
        Assays to optimize
      </label>
      <MultiSelect
        closeMenuOnSelect={false}
        isMulti
        isClearable
        isSearchable
        isDisabled={disabled}
        options={assays}
        value={selectedAssays}
        onChange={assay => onChange(assay)}
      />
    </div>
  )
}

